'use client'

import { Bookmark, BookmarkCheck } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useReserve } from './reserve-context'

// Labelled reserve toggle for the clip detail page. Shares the same basket as
// the library grid through the reserve context.

export function ReserveButton({
  id,
  size,
  className,
}: {
  id: string
  size?: 'default' | 'lg'
  className?: string
}) {
  const { has, toggle } = useReserve()
  const on = has(id)
  return (
    <Button
      type="button"
      size={size}
      variant={on ? 'default' : 'outline'}
      onClick={() => toggle(id)}
      aria-pressed={on}
      className={cn(on && 'bg-brand-lime text-brand-navy hover:bg-brand-lime/90', className)}
    >
      {on ? <BookmarkCheck className="mr-1.5 h-4 w-4" /> : <Bookmark className="mr-1.5 h-4 w-4" />}
      {on ? 'Reserved' : 'Reserve clip'}
    </Button>
  )
}
